import { useEffect } from "react";
import Intercom from "@intercom/messenger-js-sdk";
import useIntercomUserJwtQuery from "src/hooks/queries/settings/useIntercomUserJwtQuery/useIntercomUserJwtQuery";
import useUserAccount from "src/store/userAccountState";

const IntercomLauncher = () => {
  const intercomAppId = process.env.REACT_APP_INTERCOM_APP_ID || "";
  const { userAccount } = useUserAccount();
  const userId = userAccount?.id || null;
  const { data, isLoading } = useIntercomUserJwtQuery(userId);
  const intercomUserJwt = data?.token;

  useEffect(() => {
    if (!userAccount?.id) {
      if (window.Intercom && typeof window.Intercom === "function") {
        window.Intercom("shutdown");
      }
      return;
    }

    if (!intercomAppId || isLoading || !intercomUserJwt) return;

    try {
      if (window.Intercom && typeof window.Intercom === "function") {
        window.Intercom("shutdown");
      }
      Intercom({
        app_id: intercomAppId,
        intercom_user_jwt: intercomUserJwt,
      });
    } catch (error) {
      console.error("[Intercom][ERROR]:", error);
    }
  }, [intercomAppId, isLoading, intercomUserJwt, userAccount?.id]);

  return <></>;
};

export default IntercomLauncher;
